import { EFonts } from 'libs/styles/styling';
import styled from 'styled-components/macro';

interface MarkerProps {
    boldBefore: string;
    text: string;
}

export const perFEKTMarkerVariables = [
    {
        variableName: 'boldBefore' as const,
        type: 'string' as const
    },
    {
        variableName: 'text' as const,
        type: 'string' as const
    }
];

export const PerFEKTMarker = (props: MarkerProps) => {
    return (
        <S_Container>
            <S_Text>
                <S_Bold>{props.boldBefore}</S_Bold>
                {props.text}
            </S_Text>
        </S_Container>
    );
};

const S_Container = styled.div`
    width: 120px;
    height: 100px;
    padding: 2px 2px;
    border-radius: 5px;
    border: 1px solid #113042;
    display: flex;
    align-items: center;
    text-align: center;
    justify-content: center;
    color: #193143;
    background: #fffdfd;
    border: 1px solid #113042;
    box-shadow: 2px 2px 10px rgba(0, 0, 0, 0.25), inset 0px -3px 0px #022767,
        inset 0px 0px 40px 5px #aac2ff;
    border-radius: 5px;
`;

const S_Text = styled.div`
    font-family: ${EFonts.Regular};
    font-size: 14px;
    padding: 0 3px;
    margin: -3px 0 0 0;
`;

const S_Bold = styled.div`
    font-weight: bold;
`;
